import useTranslator from "../../hooks/useTranslator";

const InputField = ({
  name,
  value,
  label,
  onChange,
  isHalf = false,
  onKeyDown,
  onBeforeInput,
}) => {
  const { _t } = useTranslator();
  return (
    <div className="main-form-group">
      <div className={`form-group ${false ? "form-group-error" : ""}`}>
        <label>{_t(label)}</label>
        <input
          type="text"
          name={name}
          placeholder={_t(`enter${label}`, "Text used in onboarding process")}
          value={value}
          onChange={(e) => onChange(e)}
          required
          {...(onKeyDown && { onKeyDown })}
          {...(onBeforeInput && { onBeforeInput })}
        />
      </div>

      {false && <p className="error-message">{}</p>}
    </div>
  );
};

export default InputField;
